var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 252,
    viewBox: "0 0 254 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_f_3602_9197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 14L130.982 96.0187L156.247 17.8163L138.676 98.0619L183.5 29.0052L145.573 102.009L206.903 46.804L151.205 107.591L224.861 70L155.188 114.428L236.15 97.0123L157.249 122.053L240 126L157.249 129.947L236.15 154.988L155.188 137.572L224.861 182L151.205 144.409L206.903 205.196L145.573 149.991L183.5 222.995L138.676 153.938L156.247 234.184L130.982 155.981L127 238L123.018 155.981L97.7534 234.184L115.324 153.938L70.5 222.995L108.427 149.991L47.0969 205.196L102.795 144.409L29.1391 182L98.8124 137.572L17.8504 154.988L96.751 129.947L14 126L96.751 122.053L17.8504 97.0123L98.8124 114.428L29.1391 70L102.795 107.591L47.0969 46.804L108.427 102.009L70.5 29.0052L115.324 98.0619L97.7534 17.8163L123.018 96.0187L127 14Z",
    fill: "#B14CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3602_9197",
    x: 0,
    y: 0,
    width: 254,
    height: 252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3602_9197"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBg);
export default __webpack_public_path__ + "static/media/heart_bg.2d15f70c7ac04003e24275674e5cd25b.svg";
export { ForwardRef as ReactComponent };